import { Component, Input } from "@angular/core";
import { clientConfig } from "../../../constant/app.constant";
import { ExternalIntegrationsService } from "../../../services/externalIntegration.service";

@Component({
  selector: "app-item-info-display",
  templateUrl: "./item-info-display.component.html",
  styleUrls: ["./item-info-display.component.scss"],
})
export class ItemInfoDisplayComponent {
  @Input() itemInfo: any;
  @Input() orderNumber: any;
  @Input() itemIndex: number;

  showDetails: boolean = false;
  useExternalIntegration: boolean = clientConfig.USE_EXTERNAL_INTEGRATION;
  extractedShopifyItems: any[] = [];

  constructor(private externalIntegrationsService: ExternalIntegrationsService) { }

  ngOnInit() {
    if (this.useExternalIntegration) {
      this.getShopifyData();
    }
  }

  getShopifyData() {
    this.extractedShopifyItems = [];
    const orders = this.externalIntegrationsService.shopifyOrderDetails?.data.orders.edges;

    orders?.forEach((orderEdge) => {
      const order = orderEdge.node;
      const lineItems = order.lineItems.edges;

      lineItems.forEach((lineItemEdge) => {
        const lineItem = lineItemEdge.node;
        const variant = lineItem.variant;
        const mediaEdge = variant?.media?.edges?.[0];
        const imageUrl = mediaEdge?.node?.image?.url;
        const altText = mediaEdge?.node?.image?.altText || "";
        const unitPrice = lineItem.originalUnitPriceSet.shopMoney.amount;
        const currency = lineItem.originalUnitPriceSet.shopMoney.currencyCode;
        const description = lineItem.variant.title;

        this.extractedShopifyItems.push({
          imageUrl: imageUrl,
          itemName: lineItem.name,
          itemNumber: lineItem.sku,
          quantity: lineItem.quantity,
          orderNumber: order.name,
          unitPrice: unitPrice,
          currency: currency,
          altText: altText,
          description: description,
          brand: "",
        });
      });
    });
  }
}
